import { rest } from "msw";
import dayjs from "dayjs";
import { randUuid, } from '@ngneat/falso';

const formHandler = rest.post("/form", async (req, res, ctx) => {
  const textDecoder = new TextDecoder("utf-8");
  const buffer = await req.arrayBuffer()
  const body = JSON.parse(textDecoder.decode(buffer))
  const task = {
    ...body,
    createAt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    status:['执行中','已完成','执行失败'][Math.floor(Math.random() * 2)],
    id: randUuid()
  }
  const tasks = JSON.parse(localStorage.getItem("tasks")||'[]')
  localStorage.setItem("tasks", JSON.stringify([...tasks, task]))
  return res(
    ctx.status(200),
    ctx.json({
      data: undefined,
      errorCode: 200,
      message: "操作成功",
    })
  );
});
export default formHandler;
